module.exports = __webpack_public_path__ + "img/YB.893a52e1.png";